module.exports = __webpack_public_path__ + "img/direct.2ffeb5dc.jpg";